module.exports = __webpack_public_path__ + "static/media/photo_15.869918cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_15.jpg
// module id = 1648
// module chunks = 0